import { render, staticRenderFns } from "./SinglePondDetail.vue?vue&type=template&id=4c33b968&scoped=true&"
import script from "./SinglePondDetail.vue?vue&type=script&lang=js&"
export * from "./SinglePondDetail.vue?vue&type=script&lang=js&"
import style0 from "./SinglePondDetail.vue?vue&type=style&index=0&id=4c33b968&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33b968",
  null
  
)

export default component.exports